import { render, staticRenderFns } from "./SelectClasses.vue?vue&type=template&id=66a2b9cf&"
import script from "./SelectClasses.vue?vue&type=script&lang=js&"
export * from "./SelectClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports